import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

// Attach Authorization header if token exists
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("viajacrm_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 unauthorized
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (!error.config.url.includes("/auth/login")) {
        localStorage.removeItem("viajacrm_token");
        localStorage.removeItem("viajacrm_user");
        window.dispatchEvent(new Event("viajacrm_logout"));
      }
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const login = (username, password) =>
  http.post("/auth/login", { username, password }).then((r) => r.data);

export const getMe = () => http.get("/auth/me").then((r) => r.data);

export const logout = () => {
  localStorage.removeItem("viajacrm_token");
  localStorage.removeItem("viajacrm_user");
  window.dispatchEvent(new Event("viajacrm_logout"));
  return Promise.resolve(true);
};

// CRM endpoints
export const getSettings = () => http.get("/settings").then((r) => r.data);
export const updateSettings = (data) => http.put("/settings", data).then((r) => r.data);

export const listClients = (search = "") =>
  http.get("/clients", { params: { search } }).then((r) => r.data);
export const getClient = (id) => http.get(`/clients/${id}`).then((r) => r.data);
export const createClient = (data) => http.post("/clients", data).then((r) => r.data);
export const updateClient = (id, data) => http.put(`/clients/${id}`, data).then((r) => r.data);
export const updateStatus = (id, status) =>
  http.patch(`/clients/${id}/status`, { status }).then((r) => r.data);
export const updateReservation = (id, data) =>
  http.put(`/clients/${id}/reservation`, data).then((r) => r.data);
export const deleteClient = (id) => http.delete(`/clients/${id}`).then((r) => r.data);

export const addPayment = (id, data) =>
  http.post(`/clients/${id}/payments`, data).then((r) => r.data);
export const deletePayment = (clientId, paymentId) =>
  http.delete(`/clients/${clientId}/payments/${paymentId}`).then((r) => r.data);
export const getReminders = (days = 15) =>
  http.get("/reminders", { params: { days } }).then((r) => r.data);

export const exportUrl = (fmt) => {
  const token = localStorage.getItem("viajacrm_token") || "";
  return `${API}/export/clients.${fmt}${token ? `?token=${token}` : ""}`;
};

export const uploadDocument = (id, file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  return http
    .post(`/clients/${id}/documents`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    })
    .then((r) => r.data);
};

export const deleteDocument = (clientId, docId) =>
  http.delete(`/clients/${clientId}/documents/${docId}`).then((r) => r.data);

export const documentUrl = (clientId, docId, download = false) => {
  const token = localStorage.getItem("viajacrm_token") || "";
  const params = new URLSearchParams();
  if (token) params.set("token", token);
  if (download) params.set("download", "true");
  const qs = params.toString();
  return `${API}/clients/${clientId}/documents/${docId}${qs ? `?${qs}` : ""}`;
};

// Users management endpoints
export const getUsers = () => http.get("/users").then((r) => r.data);
export const createUser = (data) => http.post("/users", data).then((r) => r.data);
export const updateUser = (id, data) => http.put(`/users/${id}`, data).then((r) => r.data);
export const deleteUser = (id) => http.delete(`/users/${id}`).then((r) => r.data);

// Email endpoint
export const sendEmail = (clientId, payload) =>
  http.post(`/clients/${clientId}/send-email`, payload).then((r) => r.data);

// Audit endpoints
export const getClientAudit = (clientId) =>
  http.get(`/clients/${clientId}/audit`).then((r) => r.data);
export const getRecentAudit = (limit = 50) =>
  http.get("/audit", { params: { limit } }).then((r) => r.data);

// Terminals endpoints
export const getTerminals = () => http.get("/terminals").then((r) => r.data);
export const createTerminal = (data) => http.post("/terminals", data).then((r) => r.data);
export const updateTerminal = (id, data) => http.put(`/terminals/${id}`, data).then((r) => r.data);
export const deleteTerminal = (id) => http.delete(`/terminals/${id}`).then((r) => r.data);

